"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class EnhancedTableHead extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "createSortHandler", propertyIdx => event => {
      this.props.onRequestSort(event, propertyIdx);
    });

    _defineProperty(this, "onSearchChange", (e, column, searchType) => {
      var searchTerms;

      if (searchType === 'range') {
        var _this$state$searchTer;

        var range = ['', ''];

        if (((_this$state$searchTer = this.state.searchTerms) === null || _this$state$searchTer === void 0 ? void 0 : _this$state$searchTer[column]) != null) {
          range = this.state.searchTerms[column].searchValue;
        }

        if (e.target.id === 'min') {
          range = [e.target.value, range[1]];
        } else {
          range = [range[0], e.target.value];
        }

        searchTerms = _objectSpread(_objectSpread({}, this.state.searchTerms), {}, {
          [column]: {
            searchType: searchType,
            searchValue: range
          }
        });
      } else {
        // regular column search
        searchTerms = _objectSpread(_objectSpread({}, this.state.searchTerms), {}, {
          [column]: {
            searchType: searchType,
            searchValue: e.target.value
          }
        });
      }

      this.setState({
        searchTerms: searchTerms
      });
      this.props.onSearch(searchTerms);
    });

    _defineProperty(this, "onClearSearch", column => {
      var searchTerms = _objectSpread(_objectSpread({}, this.state.searchTerms), {}, {
        [column]: {
          searchType: this.state.searchTerms[column].searchType,
          searchValue: ''
        }
      });

      this.setState({
        searchTerms: searchTerms
      });
      this.props.onSearch(searchTerms);
    });

    this.state = {
      searchTerms: {}
    };
  }

  handleCustomColumn(searchOption, column, columnIdx) {
    var _this$state$searchTer2, _this$state$searchTer3, _this$state$searchTer4, _this$state$searchTer5, _this$state$searchTer6, _this$state$searchTer7, _this$state$searchTer8;

    switch (searchOption) {
      case 'range':
        return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
          key: columnIdx,
          align: "left",
          padding: "normal",
          sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : false
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row'
          }
        }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
          type: "number",
          id: "min",
          placeholder: "Min",
          value: (_this$state$searchTer2 = this.state.searchTerms[column.title]) === null || _this$state$searchTer2 === void 0 ? void 0 : (_this$state$searchTer3 = _this$state$searchTer2.searchValue) === null || _this$state$searchTer3 === void 0 ? void 0 : _this$state$searchTer3[0],
          onChange: event => this.onSearchChange(event, column.title, 'range'),
          style: {
            width: '75px',
            marginRight: '.5em'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, "to"), /*#__PURE__*/_react.default.createElement(_material.TextField, {
          type: "number",
          id: "max",
          placeholder: "Max",
          value: (_this$state$searchTer4 = this.state.searchTerms[column.title]) === null || _this$state$searchTer4 === void 0 ? void 0 : (_this$state$searchTer5 = _this$state$searchTer4.searchValue) === null || _this$state$searchTer5 === void 0 ? void 0 : _this$state$searchTer5[1],
          onChange: event => this.onSearchChange(event, column.title, 'range'),
          style: {
            width: '75px',
            marginLeft: '.5em'
          }
        })));

      case 'column':
        return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
          key: columnIdx,
          align: "left",
          padding: "normal",
          sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : false
        }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
          placeholder: "Search",
          style: {
            width: '100%',
            marginRight: 10
          },
          value: (_this$state$searchTer6 = this.state.searchTerms[column.title]) === null || _this$state$searchTer6 === void 0 ? void 0 : _this$state$searchTer6.searchValue,
          onChange: event => this.onSearchChange(event, column.title, 'column'),
          variant: "outlined",
          InputProps: {
            endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
              position: "end"
            }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
              "aria-label": "toggle password visibility",
              onClick: () => this.onClearSearch(column.title),
              edge: "end"
            }, ((_this$state$searchTer7 = this.state.searchTerms[column.title]) === null || _this$state$searchTer7 === void 0 ? void 0 : (_this$state$searchTer8 = _this$state$searchTer7.searchValue) === null || _this$state$searchTer8 === void 0 ? void 0 : _this$state$searchTer8.length) > 0 ? /*#__PURE__*/_react.default.createElement(_Close.default, null) : null))
          }
        }));

      default:
        return /*#__PURE__*/_react.default.createElement(_material.TableCell, null);
    }
  }

  render() {
    var _this$props$columns, _this$props$columns2;

    return /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, this.props.columns.map((column, columnIdx) => /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      key: columnIdx,
      align: "left",
      padding: "normal",
      sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : false
    }, /*#__PURE__*/_react.default.createElement(_material.TableSortLabel, {
      active: this.props.orderByIdx === columnIdx && (column.field || column.customSort),
      direction: this.props.orderByIdx === columnIdx ? this.props.order : 'asc',
      onClick: this.createSortHandler(columnIdx),
      disabled: !column.field && !column.customSort
    }, column.title)))), (((_this$props$columns = this.props.columns) === null || _this$props$columns === void 0 ? void 0 : _this$props$columns.find(column => column.search === 'column')) != null || ((_this$props$columns2 = this.props.columns) === null || _this$props$columns2 === void 0 ? void 0 : _this$props$columns2.find(column => column.search === 'range')) != null || this.props.searchType === 'column') && /*#__PURE__*/_react.default.createElement(_material.TableRow, null, this.props.columns.map((column, columnIdx) => column.title !== 'View' ? this.props.searchType === 'column' && column.search == null ? this.handleCustomColumn('column', column, columnIdx) : this.handleCustomColumn(column.search, column, columnIdx) : /*#__PURE__*/_react.default.createElement(_material.TableCell, null))));
  }

}

EnhancedTableHead.propTypes = {
  onRequestSort: _propTypes.default.func.isRequired,
  order: _propTypes.default.oneOf(['asc', 'desc']).isRequired,
  orderByIdx: _propTypes.default.string.isRequired,
  columns: _propTypes.default.array.isRequired,
  onClearSearch: _propTypes.default.func.isRequired,
  searchValues: _propTypes.default.array.isRequired,
  onSearch: _propTypes.default.func.isRequired,
  searchType: _propTypes.default.string
};
var _default = EnhancedTableHead;
exports.default = _default;